var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"logo-badge",attrs:{"to":{name: 'Home'}}},[_c('img',{attrs:{"src":require('@/assets/img/logo_blue.png'),"alt":""}}),_c('p',[_c('span',{staticStyle:{"font-style":"italic"}},[_vm._v("L'TAS Pâtisserie")]),_c('br'),_vm._v(" 拉塔斯點心鋪 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }